import { render, staticRenderFns } from "./vieFullData.vue?vue&type=template&id=6357c55e&scoped=true"
import script from "./vieFullData.vue?vue&type=script&lang=js"
export * from "./vieFullData.vue?vue&type=script&lang=js"
import style0 from "./vieFullData.vue?vue&type=style&index=0&id=6357c55e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6357c55e",
  null
  
)

export default component.exports